import { render, staticRenderFns } from "./4.vue?vue&type=template&id=32742cb4&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=32742cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32742cb4",
  null
  
)

export default component.exports